const DeviceReplacement = {
  DeviceReplacement: {
    toDoText: 'Por favor, asegúrese de que los siguientes pasos se han realizado antes de iniciar la sustitución',
    toDoListItems: [
      'Desconecte el dispositivo a sustituir',
      'Conecte el dispositivo de sustitución',
      'Configure el dispositivo de sustitución'
    ],
    install_replacement: {
      submitFirstStep: 'Obtener detalles',
      hems_device_api_fault:
        'Si está intentando sustituir una carga de terceros activa pero no puede verla en el menú desplegable, vuelva a cargar la página.',
      labelOldDevice: 'Detalles del dispositivo antiguo',
      labelNewDevice: 'Detalles del dispositivo nuevo',
      submitSecondStep: 'Confirme la sustitución',
      warningText: `En caso de que los datos del dispositivo sean incorrectos o por cualquier otro motivo, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >haga clic aquí</a> para volver atrás.`,
      DeviceTypes: {
        EVSE: 'IQ ER EVSE',
        ENERGY_METER: 'Contador de energía',
        SG_READY_GATEWAY: 'Relé SG Ready',
        MICROINVERTER: 'Microinversor',
        AC_BATTERY: 'Batería AC',
        selectDeviceType: 'seleccione el tipo de dispositivo'
      }
    },
    replace_gateway: {
      hems_device_api_fault:
        'Si está intentando sustituir un IQ Energy Router activo pero no puede verlo en el menú desplegable, vuelva a cargar la página.',
      submitSecondStep: 'Sustituir IQ Energy Router',
      labelOldDevice: 'Detalles del antiguo IQ ER',
      labelNewDevice: 'Detalles del nuevo IQ ER',
      warningText: `En caso de que los datos del dispositivo sean incorrectos o por cualquier otro motivo, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >haga clic aquí</a> para volver atrás.`,
      submitFirstStep: 'Sustituir IQ Energy Router',
      DeviceTypes: {
        IQ_ENERGY_ROUTER: 'IQ Energy Router',
        IQ_GATEWAY: 'IQ Gateway',
        selectGatewayType: 'Select Gateway '
      }
    },
    alert: {
      footerMessage:
        'En caso de que el problema persista, póngase en contacto con el servicio de atención al cliente de Enphase.',
      requestTimedOut: {
        mainMessage: 'Solicitud agotada',
        subMessage: 'Vuelva a intentarlo más tarde'
      },
      multipleDeviceFound: {
        mainMessage: 'No se admite la sustitución',
        subMessageIqErEvse:
          'Se han detectado más de 1 IQ ER EVSE en el emplazamiento. No se admite la sustitución para este tipo de configuración de emplazamiento.',
        subMessageEnergyMeter:
          'Se han detectado más de 1 contadores de energía en el emplazamiento. La sustitución no es compatible con este tipo de configuración del emplazamiento.',
        subMessageSgReadyRelay:
          'Se detectan más de 1 relés SG Ready en la instalación. La sustitución no es posible en este tipo de configuración.'
      },
      iqErOffline: {
        mainMessage: 'IQ ER no informa',
        subMessage: 'Asegúrese de que el IQ Energy Router está encendido y conectado a Internet.'
      },
      deviceNotOffline: {
        mainMessage: 'Dispositivo antiguo conectado',
        subMessage:
          'Se ha detectado la conexión de un dispositivo antiguo. Por favor, desconecte el dispositivo antiguo y vuelva a iniciar la sustitución'
      },
      deviceReplacementInProgress: {
        mainMessage: 'La sustitución del dispositivo ya está en curso para este tipo de dispositivo'
      },
      deviceNotFound: {
        mainMessage: 'Nuevo dispositivo no detectado',
        subMessage:
          'No se han encontrado los detalles del nuevo dispositivo. Asegúrese de que el nuevo dispositivo está conectado a Internet y configurado.'
      },
      invalidRmaStatusId: {
        mainMessage: 'Sustitución fallida ',
        subMessage: 'Sustitución fallida debido a un estado de sustitución desconocido'
      },
      activationDuplicateSite: {
        mainMessage: 'Sustitución fallida',
        subMessage: 'La sustitución ha fallado porque el nuevo IQ Energy Router ya está activo'
      },
      authPending: {
        mainMessage: 'Sustitución fallida',
        subMessage: 'La sustitución ha fallado porque el IQ Energy Router existente aún no está autorizado'
      },
      invalidIqEnergyRouter: {
        mainMessage: 'Sustitución fallida',
        subMessage: 'Fallo en la sustitución porque el número de serie del IQ Energy Router introducido no es válido'
      },
      hemsDevicesNotDiscovered: {
        mainMessage: 'Sustitución fallida',
        subMessage:
          'Fallo en la sustitución porque no se han encontrado los dispositivos HEMS de terceros detectados anteriormente'
      },
      iqGatewayNotDiscovered: {
        mainMessage: 'Sustitución fallida',
        subMessage: 'Fallo en la sustitución porque el IQ Energy Router aún no ha detectado el IQ Gateway'
      },
      authInitFailed: {
        mainMessage: 'Sustitución fallida',
        subMessage: 'Fallo en la sustitución porque no se ha iniciado la autorización del dispositivo'
      },
      invalidDeviceType: {
        mainMessage: 'El tipo de dispositivo no es válido para la sustitución',
        subMessage: 'Asegúrese de haber seleccionado el tipo de dispositivo correcto antes de enviar la solicitud.'
      },
      invalidSite: {
        mainMessage: 'Tipo de emplazamiento no compatible',
        subMessage: 'La configuración del sitio no admite esta sustitución'
      },
      invalidDevice: {
        mainMessage: 'El ID de dispositivo antiguo no parece válido',
        subMessage: 'No se admite la sustitución de este dispositivo'
      },
      invalidDeviceUid: {
        mainMessage: 'Los ID de dispositivo antiguo y nuevo son iguales',
        subMessage: 'No se admite la sustitución de este dispositivo'
      },
      deviceReplacementCompleted: {
        mainMessage: 'Sustitución completa',
        subMessage:
          'Si la validación funcional está pendiente para el nuevo dispositivo, complétela utilizando la Enphase Installer Application (ITK).'
      },
      itkSuccessMessage: {
        iqErEvse: 'Cargador EV sustituido con éxito',
        energyMeter: 'Medidor de energía sustituido con éxito',
        sgReadyRelay: 'SG Ready Relay sustituido con éxito',
        iqEnergyRouter: 'IQ Energy Router sustituido con éxito'
      },
      fetchingDeviceDetailsLoader: { subMessage: 'Obtener detalles del dispositivo' },
      initiatingReplacementLoader: { subMessage: 'Iniciando sustitución' },
      replacementInprogressLoader: { subMessage: 'Sustitución en curso' }
    }
  }
};

export default DeviceReplacement;
